__turbopack_context__.v({
  "avatar": "avatar-module-scss-module__WGcsRa__avatar",
  "badge": "avatar-module-scss-module__WGcsRa__badge",
  "border": "avatar-module-scss-module__WGcsRa__border",
  "container": "avatar-module-scss-module__WGcsRa__container",
  "has-image": "avatar-module-scss-module__WGcsRa__has-image",
  "image": "avatar-module-scss-module__WGcsRa__image",
  "initials": "avatar-module-scss-module__WGcsRa__initials",
  "large": "avatar-module-scss-module__WGcsRa__large",
  "medium": "avatar-module-scss-module__WGcsRa__medium",
  "placeholder": "avatar-module-scss-module__WGcsRa__placeholder",
  "responsive-image": "avatar-module-scss-module__WGcsRa__responsive-image",
  "xlarge": "avatar-module-scss-module__WGcsRa__xlarge",
});
